import {
  Badge,
  Button,
  Drawer,
  List,
  Typography,
  Row,
  message,
  Grid,
  Modal,
} from "antd";
import { useState, useEffect } from "react";
import { useMobxStores } from "../../stores/stores";
import { observer } from "mobx-react";
import { DeleteOutlined } from "@ant-design/icons";
import "./CartDropdownMenu.css";
import CartIcon from "../../assets/cart-icon.png";
import CartIconWhite from "../../assets/cart-icon-white.png";
import { useLocation } from "react-router-dom";
import { keycloak } from "../../utils/keycloak";
const { useBreakpoint } = Grid;
const { Text } = Typography;

const CartDropdownMenu = () => {
  const screens = useBreakpoint();

  const size = () => {
    let size;
    if (screens.xxl) size = 558;
    else if (screens.xl) size = 510;
    else if (screens.lg) size = 480;
    else size = 420;
    return size;
  };
  const { marketplaceStore } = useMobxStores();
  const [visible, setVisible] = useState(false);
  const [items, setItems] = useState([]);
  const { pathname } = useLocation();
  const isMobile = !screens.sm;

  useEffect(() => {
    if (Array.isArray(marketplaceStore.cart.items_list)) {
      setItems(marketplaceStore.cart.items_list);
      marketplaceStore.GetCartListings();
    } else {
      setItems([]);
    }
  }, [marketplaceStore.cart]);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const matchListingsToItems = (listingsToRemove) => {
    listingsToRemove.forEach((listing) => {
      const itemToRemove = marketplaceStore.cart.items_list.find(
        (item) => item.nft === listing.nft
      );
      if (itemToRemove) {
        onRemoveFromCart(itemToRemove.id, [listing]);
      }
    });
  };

  const removeOutdatedCartListings = async () => {
    const oldListings = marketplaceStore.cartListings;
    await marketplaceStore.GetCartListings();
    const listingsToRemove = [];

    oldListings.forEach((listing) => {
      const cartListing = marketplaceStore.cartListings.find(
        (cartListing) => cartListing.id === listing.id
      );
      if (!cartListing) {
        listingsToRemove.push(listing);
        return;
      }
      if (
        cartListing.quantity !== listing.quantity ||
        cartListing.total_price !== listing.total_price
      ) {
        listingsToRemove.push(listing);
      }
    });
    matchListingsToItems(listingsToRemove);
  };

  const onBatchBuyNFT = async () => {
    const metamaskData = localStorage.getItem("metaMask");
    if (!metamaskData) {
      message.error("Please connect to Metamask first");
      return;
    }

    marketplaceStore.setBuyInProgress(true);
    await removeOutdatedCartListings();

    const filteredPurchaseInfo = marketplaceStore.cart.purchase_info?.map(
      (info) => ({
        listing: info.listing,
        quantity: info.quantity,
      })
    );

    const values = {
      account: metamaskData,
      purchase_info: filteredPurchaseInfo,
    };
    try {
      await window.ethereum.request({
        method: "wallet_switchEthereumChain",
        params: [
          {
            chainId: `0x${marketplaceStore.cart.items_list[0].chainid.toString(
              16
            )}`,
          },
        ],
      });
      await marketplaceStore.BatchBuyNFT(values);
    } catch (error) {
      console.error(error);
    } finally {
      marketplaceStore.setBuyInProgress(false);
    }
  };

  const onRemoveFromCart = async (id, matchingListings) => {
    try {
      let values = [...marketplaceStore.cart.items];

      values = values.filter((item) => item !== id);
      values.length === 0 && marketplaceStore.setCartCurrency("");

      let purchaseInfo = [...marketplaceStore.cart.purchase_info];
      matchingListings.forEach((obj) => {
        purchaseInfo = purchaseInfo.filter((info) => info.listing !== obj.id);
      });

      const updatedValues = { items: values, purchase_info: purchaseInfo };
      await marketplaceStore.UpdateCart(updatedValues);
    } catch (error) {
      console.error(error);
      message.error("Failed to clear cart");
    }
  };

  const getPurchaseInfoAndListing = (item) => {
    const purchaseInfo = marketplaceStore.cart?.purchase_info?.filter(
      (info) => info.nft_id === item.nft
    );

    const matchingListings =
      marketplaceStore.cartListings?.filter((listing) =>
        purchaseInfo?.some((info) => info.listing === listing.id)
      ) || [];

    return [purchaseInfo, matchingListings];
  };

  const calculateItemPrice = (matchingListings, purchaseInfo) => {
    const price = matchingListings?.reduce((acc, currentListing) => {
      const info = purchaseInfo.find(
        (info) => info.listing === currentListing.id
      );
      const currentPrice =
        (currentListing.total_price * info.quantity) / info.available_quantity;

      return acc + currentPrice;
    }, 0);

    return price;
  };

  const calculateTotalPrice = (items) => {
    const totalPrice = items?.reduce((acc, current) => {
      const [purchaseInfo, matchingListings] =
        getPurchaseInfoAndListing(current);

      const price = calculateItemPrice(matchingListings, purchaseInfo);

      return acc + parseFloat(price);
    }, 0);

    return totalPrice;
  };

  return (
    <>
      {/* <Button type="link" onClick={showDrawer}> */}
      <Badge
        offset={isMobile ? [-4, 4] : [-10, 10]}
        count={marketplaceStore.cart.items.length}
        onClick={() => {
          if (keycloak.authenticated) {
            showDrawer();
          } else {
            Modal.confirm({
              title: "Sign in required",
              content:
                "You are not allowed to perform this action. You need to sign in first.",
              okText: "Sign in",
              cancelText: "Cancel",
              onOk: () => keycloak.login({ redirectUri: window.location.href }),
            });
          }
        }}
      >
        <img
          className="cart-icon"
          src={
            pathname === "/" || pathname === "/moderation"
              ? CartIconWhite
              : CartIcon
          }
          alt="cart"
        />
      </Badge>
      {/* </Button> */}
      <Drawer
        title={
          <span
            style={{
              color: "rgb(0 0 128)",
              fontWeight: "600",
              // fontSize: "42px",
            }}
            className="DrawerTitle"
          >
            Your cart
          </span>
        }
        placement="right"
        onClose={onClose}
        open={visible}
        width={size()}
      >
        <List
          itemLayout="horizontal"
          dataSource={items}
          renderItem={(item) => {
            const [purchaseInfo, matchingListings] =
              getPurchaseInfoAndListing(item);

            return (
              <List.Item style={{ borderBottom: "1px solid #9C9999" }}>
                <List.Item.Meta
                  className="purchase-cart-list-item-meta"
                  avatar={
                    <img
                      src={item.display_image.thumbnail}
                      alt={item.name}
                      className="drawerProperties"
                      style={{
                        borderRadius: "10px",
                        objectFit: "cover",
                      }}
                    />
                  }
                  title={
                    <span
                      style={{
                        width: "100%",
                        textOverflow: "ellipsis",
                        fontWeight: "600",

                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        display: "block",
                        color: "#000080",
                      }}
                      className="product-title"
                    >
                      {item.name}
                    </span>
                  }
                  description={
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      {marketplaceStore.cart.purchase_info?.find(
                        (info) => info.nft_id === item.nft
                      )?.royalty_value && (
                        <Text
                          style={{
                            fontWeight: "400",
                            fontSize: "18px",
                            color: "#000080",
                          }}
                        >
                          Royalty: {purchaseInfo[0]?.royalty_value}%
                        </Text>
                      )}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "end",
                          justifyContent: "space-between",
                        }}
                      >
                        <Text
                          style={{
                            fontWeight: "400",
                            fontSize: "18px",
                            display: "block",
                            lineHeight: "18px",
                            textWrap: "nowrap",
                            color: "#000080",
                          }}
                        >
                          Price:{" "}
                          {calculateItemPrice(matchingListings, purchaseInfo)}
                          {marketplaceStore.cart.items_list[0] &&
                          marketplaceStore.cart.items_list[0].chainid ===
                            11155111
                            ? "ETH"
                            : "MATIC"}
                        </Text>
                        <div
                          style={{
                            display: "flex",
                            gap: "16px",
                            alignItems: "end",
                          }}
                        >
                          <div
                            style={{
                              width: "32px",
                              height: "32px",
                              border: "1px solid black",
                              borderRadius: "5px",
                              fontSize: "20px",
                              fontWeight: "400",
                              color: "rgb(208, 31, 223)",
                              textAlign: "center",
                              verticalAlign: "middle",
                              lineHeight: "32px",
                            }}
                          >
                            {purchaseInfo?.reduce(
                              (acc, current) => acc + current.quantity,
                              0
                            )}
                          </div>
                          <Button
                            type="link"
                            icon={
                              <DeleteOutlined
                                style={{ color: "rgb(208, 31, 223)" }}
                              />
                            }
                            onClick={() =>
                              onRemoveFromCart(item.id, matchingListings)
                            }
                            danger
                            key={1}
                          />
                        </div>
                      </div>
                    </div>
                  }
                />
                <div>
                  {item.price} {item.price_currency}
                </div>
              </List.Item>
            );
          }}
        />
        <div
          style={{
            marginTop: 28,
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          <Row>
            {marketplaceStore.cart?.items_list?.length > 0 && (
              <div style={{ display: "flex", gap: "24px" }}>
                <Text
                  className="DrawerTotal"
                  style={{
                    // fontSize: "32px",
                    fontWeight: "600",
                    color: "#000080",
                  }}
                >
                  Total price:
                </Text>
                <Text
                  className="DrawerTotal"
                  style={{
                    // fontSize: "32px",
                    fontWeight: "600",
                    color: "#000080",
                  }}
                >
                  {items.length > 0 ? calculateTotalPrice(items) : null}{" "}
                  {marketplaceStore.cart.items_list[0].chainid === 11155111
                    ? "ETH"
                    : "MATIC"}
                </Text>
              </div>
            )}
          </Row>
          <Row
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            {items.length > 0 && (
              <button
                type="primary"
                className="cart-purchase-button"
                onClick={onBatchBuyNFT}
              >
                Complete purchase
              </button>
            )}
          </Row>
        </div>
      </Drawer>
    </>
  );
};

export default observer(CartDropdownMenu);
